import React, { memo } from 'react';
import { motion } from 'framer-motion';
import { Check, Gift } from 'lucide-react';
export function BonusSection() {
  const bonuses = [{
    id: 1,
    title: 'Mini Recetario de Bebidas Saludables',
    image: 'https://cdn.magicpatterns.com/uploads/fQ8HWYoyeN5aHa14yQL4wR/ChatGPT_Image_Jan_21,_2026,_10_29_37_PM.png',
    objection: 'Objeción que elimina: "Mi hijo no quiere tomar nada cuando está enfermo"',
    desc: 'Todo protocolo natural falla si tu peque no está hidratado. Y la hidratación no es opcional. El problema: los niños enfermos rechazan el agua.',
    features: ['Bebidas naturales diseñadas para niños que rechazan líquidos', 'Ingredientes que ya tienes en tu cocina', 'Preparación en menos de 5 minutos', 'Fórmulas específicas para fiebre, gripe, tos y dolor de barriga'],
    value: '$12 USD'
  }, {
    id: 2,
    title: 'Checklist de Salud PequeSalud',
    image: 'https://cdn.magicpatterns.com/uploads/8YfX9UmH1GYsKLDTECryux/ChatGPT_Image_Jan_21,_2026,_10_17_20_PM.png',
    objection: 'Objeción que elimina: "Agotada y en pánico, voy a olvidar pasos importantes"',
    desc: 'A las 2AM, cuando tu hijo tiene fiebre y llevas horas sin dormir... La memoria falla. Este checklist es tu red de seguridad.',
    features: ['Lista paso a paso de qué hacer primero', 'Casillas de verificación para no olvidar nada', 'Diseñado para usarse en 30 segundos', 'Imprimible y digital'],
    value: '$12 USD'
  }, {
    id: 3,
    title: 'Tabla Comparativa de Síntomas y Remedios',
    image: 'https://cdn.magicpatterns.com/uploads/1PBiEmjcyEGSTdGVczFqKH/ChatGPT_Image_Jan_21,_2026,_10_38_29_PM.png',
    objection: 'Objeción que elimina: "¿Y si confundo los síntomas?"',
    desc: 'Una tos puede ser gripe. O congestión. Y el remedio cambia. Esta tabla es el mapa que necesitas cuando todo está oscuro.',
    features: ['Comparativa visual de síntomas similares', 'Remedio natural recomendado para cada uno', 'Indicadores claros de cuándo ir al médico', 'Formato visual para consultar en segundos'],
    value: '$12 USD'
  }];
  return <section className="py-24 bg-white" data-id="element-16">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-17">
        <div className="text-center mb-16" data-id="element-18">
          <span className="bg-terracotta/10 text-terracotta-dark px-4 py-1 rounded-full text-sm font-bold uppercase tracking-wide" data-id="element-19">
            Bonos Exclusivos
          </span>
          <h2 className="text-3xl md:text-4xl font-bold text-forest mt-4 font-serif" data-id="element-20">
            Diseñados para eliminar tus dudas
          </h2>
        </div>

        <div className="space-y-20" data-id="element-21">
          {bonuses.map((bonus, idx) => <motion.div key={bonus.id} initial={{
          opacity: 0,
          y: 40
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6
        }} className={`flex flex-col ${idx % 2 === 1 ? 'lg:flex-row-reverse' : 'lg:flex-row'} gap-12 items-center`} data-id="element-22">
              {/* Image */}
              <div className="w-full lg:w-1/2" data-id="element-23">
                <div className="relative group" data-id="element-24">
                  <div className="absolute -inset-4 bg-sage/10 rounded-2xl transform rotate-2 group-hover:rotate-1 transition-all duration-300" data-id="element-25"></div>
                  <img src={bonus.image} alt={bonus.title} className="relative rounded-xl shadow-lg w-full object-cover border border-sage/20" data-id="element-26" />
                  <div className="absolute top-4 left-4 bg-terracotta text-white px-4 py-1 rounded-full font-bold shadow-md" data-id="element-27">
                    BONO #{bonus.id}
                  </div>
                </div>
              </div>

              {/* Content */}
              <div className="w-full lg:w-1/2 space-y-6" data-id="element-28">
                <h3 className="text-2xl md:text-3xl font-bold text-forest font-serif" data-id="element-29">
                  {bonus.title}
                </h3>

                <div className="bg-cream border-l-4 border-terracotta p-4 rounded-r-lg" data-id="element-30">
                  <p className="text-terracotta-dark font-medium italic text-sm" data-id="element-31">
                    {bonus.objection}
                  </p>
                </div>

                <p className="text-forest/80 text-lg leading-relaxed" data-id="element-32">
                  {bonus.desc}
                </p>

                <ul className="space-y-3" data-id="element-33">
                  {bonus.features.map((feature, i) => <li key={i} className="flex items-start gap-3" data-id="element-34">
                      <Check className="h-5 w-5 text-sage-dark flex-shrink-0 mt-1" data-id="element-35" />
                      <span className="text-forest/70" data-id="element-36">{feature}</span>
                    </li>)}
                </ul>

                <div className="pt-4 flex items-center gap-2" data-id="element-37">
                  <Gift className="h-5 w-5 text-terracotta" data-id="element-38" />
                  <p className="font-bold text-forest" data-id="element-39">
                    Valor:{' '}
                    <span className="line-through opacity-50" data-id="element-40">
                      {bonus.value}
                    </span>{' '}
                    — <span className="text-terracotta" data-id="element-41">Tuyo gratis hoy.</span>
                  </p>
                </div>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}